import React from 'react';
import {
  LucideGithub,
  LucideLinkedin,
  LucideTwitter,
} from 'lucide-react';

// Bu bileşen, Ekibimiz sayfasının tamamını içerir.
// Tailwind CSS kullanılarak tamamen duyarlı (responsive) olarak tasarlanmıştır.
const App = () => {
  // Örnek ekip üyesi verileri. Bu verileri daha sonra backend'inizden alabilirsiniz.
  const teamMembers = [{
    id: 1,
    name: 'Eren İşler',
    title: 'Kurucu',
    description: 'Şirketin vizyonunu ve büyüme stratejilerini yönetir. Mekanlara olan tutkusu ile bu platformu hayata geçirmiştir.',
    image: 'https://placehold.co/400x400/1e293b/d4d4d8?text=Eİ', // Örnek resim URL'si
    social: {
      twitter: '#',
      linkedin: '#',
      github: '#',
    },
  },
  {
    id: 2,
    name: 'Serkan Dere',
    title: 'Pazarlama Müdürü',
    description: 'Mekaname\'nin marka bilinirliğini artırmak ve kullanıcı kitlesini genişletmek için çalışır. Yaratıcı kampanyalar tasarlar.',
    image: 'https://placehold.co/400x400/1e293b/d4d4d8?text=SD',
    social: {
      twitter: '#',
      linkedin: '#',
      github: '#',
    },
  },  
  /*{
    id: 3,
    name: '*** ***',
    title: 'Teknoloji Direktörü (CTO)',
    description: 'Platformun tüm teknolojik altyapısından sorumludur. React, Python ve SQLAlchemy uzmanıdır.',
    image: 'https://placehold.co/400x400/1e293b/d4d4d8?text=TD',
    social: {
      twitter: '#',
      linkedin: '#',
      github: '#',
    },
  }, 

  {
    id: 4,
    name: '*** ***',
    title: 'İçerik Editörü',
    description: 'Mekan incelemelerini yazar ve platformdaki tüm içeriklerin kalitesini kontrol eder. Mekan keşfetmeyi sever.',
    image: 'https://placehold.co/400x400/1e293b/d4d4d8?text=İE',
    social: {
      twitter: '#',
      linkedin: '#',
      github: '#',
    },
  }*/
];

  return (
    <div className="min-h-screen bg-slate-900 text-slate-200 font-sans p-4 sm:p-8">
      {/* Sayfa başlığı ve alt metni */}
      <div className="text-center max-w-3xl mx-auto mb-12">
        <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500">
            Ekibimizle Tanışın
        </h1>
        <p className="text-lg text-slate-400">
          Mekânname'yi hayata geçiren, mekanlara tutkulu ve yenilikçi ekibimiz.
        </p>
      </div>

      {/* Ekip üyelerini sergileyen duyarlı ızgara (grid) düzeni */}
      <div className="grid grid-cols-1 sm:grid-cols-2  gap-8 max-w-7xl mx-auto">
        {teamMembers.map((member) => (
          <div
            key={member.id}
            className="group flex flex-col items-center p-6 bg-slate-800 rounded-2xl shadow-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:bg-slate-700 cursor-pointer"
          >
            {/* Üye resmi */}
            <img
              src={member.image}
              alt={member.name}
              className="w-32 h-32 object-cover rounded-full mb-4 ring-4 ring-slate-600 transition-all duration-300 group-hover:ring-teal-400"
            />
            {/* Üye Adı */}
            <h3 className="text-2xl font-bold text-white mb-1">
              {member.name}
            </h3>
            {/* Üye Pozisyonu */}
            <p className="text-md text-teal-400 font-semibold mb-4">
              {member.title}
            </p>
            {/* Üye Açıklaması */}
            <p className="text-center text-sm text-slate-400 leading-relaxed mb-4">
              {member.description}
            </p>
            {/* Sosyal medya ikonları */}
            <div className="flex gap-4">
              <a href={member.social.twitter} className="text-slate-400 hover:text-teal-400 transition-colors duration-200">
                <LucideTwitter size={20} />
              </a>
              <a href={member.social.linkedin} className="text-slate-400 hover:text-teal-400 transition-colors duration-200">
                <LucideLinkedin size={20} />
              </a>
              <a href={member.social.github} className="text-slate-400 hover:text-teal-400 transition-colors duration-200">
                <LucideGithub size={20} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default App;
